import { FC, useState } from 'external/react'
import { Accordion, AccordionDetails, AccordionSummary, Typography, styled} from 'external/material'

import CrossIconToggleButton from 'components/common/CrossIconToggleButton'

type CrossAccordionProps = {
  title: string
  expandedByDefault?: boolean
}

const StyledCrossAccordion = styled(Accordion)(crossAccordionStyles as any)

const CrossAccordion: FC<CrossAccordionProps> = props => {
  const {title, children, expandedByDefault = false} = props
  const [expanded, setExpanded] = useState<boolean>(expandedByDefault)
  return (
    <StyledCrossAccordion expanded={expanded} onChange={() => setExpanded((prev) => !prev)} sx={{}} disableGutters={true} elevation={0}>
      <AccordionSummary expandIcon={<CrossIconToggleButton boxSize={44} expanded={expanded} onChange={setExpanded}/>}>
        <Typography component='span'>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {children}
      </AccordionDetails>
    </StyledCrossAccordion>
  )
}

export {CrossAccordion as default}

function crossAccordionStyles() {
  return {
    '&::before': {
      display: 'none'
    } ,   
    '& .MuiAccordionSummary-root': {
      backgroundColor: 'rgba(165, 211, 243, 0.5)',
      '& span': {
        fontWeight: 'bold',
        color: 'rgba(0,0,30,1)' 
      }
    },
    '& .MuiAccordionDetails-root': {
      padding: 0
    }
  }
}